import React from 'react'

import { Table, TableAlign, TableCell, TableFooter, TableHead, TableHeader } from '../../components/Table'
import PriceReactionTableRow from './PriceReactionTableRow'
import { PriceReactionColumnDefinition, PriceReactionRowDataType, PriceReactionSubColumnDefinition } from './types'

type PriceReactionTableProps<
  RowDataType extends PriceReactionRowDataType,
  ColumnDefinition extends PriceReactionColumnDefinition,
> = {
  data: RowDataType[]
  columns: ColumnDefinition[]
  subColumns?: Record<string, PriceReactionSubColumnDefinition[]>
}

export default function PriceReactionTable<
  RowDataType extends PriceReactionRowDataType,
  ColumnDefinition extends PriceReactionColumnDefinition,
>({ columns, subColumns, data }: PriceReactionTableProps<RowDataType, ColumnDefinition>) {
  return (
    <Table className="table-fixed leading-4 [overflow-anchor:none]">
      <TableHead>
        <TableHeader align={TableAlign.Left} className="w-56">
          Report Date
        </TableHeader>
        {columns.map((column) => (
          <TableHeader
            key={column.id}
            align={column.align}
            className={column.headerClassName}
            hasPadding={!column.isSeparator}
          >
            {column.name}
          </TableHeader>
        ))}
      </TableHead>
      {data.map((row, index) => (
        <PriceReactionTableRow
          key={row.id ?? row.label}
          data={row}
          columns={columns}
          subColumns={subColumns}
          isFirst={index === 0}
          isLast={index === data.length - 1}
        />
      ))}
      <TableFooter>
        <TableCell className="pt-1 text-muted-2" colSpan={columns.length + 1}>
          Daily change and RSI 14 are based on the report date for BMO releases and the following day for AMC releases.
        </TableCell>
      </TableFooter>
    </Table>
  )
}
